import { useEffect, useState } from 'react'
import { timeSince } from 'utils'

import {
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay
} from '@chakra-ui/react'
import { Flex, Tag, Text, chakra } from '@chakra-ui/react'
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel
} from '@chakra-ui/react'

import VexInfo from 'components/Drawer/VexInfo'

import { useThemeColor } from 'hooks/useThemeColors'

const HistoryDrawer = ({ data, isOpen, onClose }) => {
  const [sortedData, setSortedData] = useState([])

  const { primaryBlueText, secondaryTextColor } = useThemeColor([
    'primaryBlueText',
    'secondaryTextColor'
  ])

  useEffect(() => {
    if (data?.logs?.length > 0) {
      const sorted = [...data.logs].sort(
        (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
      )
      setSortedData(sorted)
    }
  }, [data.logs])

  return (
    <Drawer
      size='md'
      isOpen={isOpen}
      placement='right'
      onClose={onClose}
      closeOnOverlayClick={false}
    >
      <DrawerOverlay />
      <DrawerContent>
        <DrawerCloseButton mt={3} />
        <DrawerHeader pb={1} borderBottomWidth='1px'>
          <Text mb={1} fontWeight={'medium'}>
            Status History
          </Text>
          <Tag colorScheme='blue'>{data?.vulnId}</Tag>
        </DrawerHeader>
        <DrawerBody p={0}>
          <Accordion m={0} px={2} allowToggle>
            {sortedData?.map((item, index) => (
              <AccordionItem
                key={index}
                mt={1}
                borderTop={index === 0 ? 0 : '-moz-initial'}
              >
                <AccordionButton py={3}>
                  <Flex
                    alignItems={'flex-start'}
                    sx={{ flex: 1, textAlign: 'left', flexDir: 'column' }}
                  >
                    <Text>{item?.status || 'N/A'}</Text>
                    <Flex
                      color={secondaryTextColor}
                      sx={{ gap: 1, alignItems: 'center' }}
                    >
                      <chakra.span fontSize={'xs'}>
                        {timeSince(item?.updatedAt)}
                      </chakra.span>
                      <chakra.span fontSize={'xs'}>•</chakra.span>
                      <chakra.span fontSize={'xs'}>
                        {item?.changedBy}
                      </chakra.span>
                    </Flex>
                  </Flex>
                  <AccordionIcon color={primaryBlueText} />
                </AccordionButton>
                <AccordionPanel pb={4}>
                  <VexInfo data={item} fields={data?.fields} />
                </AccordionPanel>
              </AccordionItem>
            ))}
          </Accordion>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  )
}

export default HistoryDrawer
